module.exports = __webpack_public_path__ + "img/alert3.6c5afbfd.png";